export default "__VITE_ASSET__DmLzu4ca__"